<template lang="pug">
#app.container
  shMessage
  shLoader
  .app-layout(v-if="!menuPrincipalHidden")
    .menu-section(v-if="!menuPrincipalHidden")
      shMenu(ref="menu")
    .content-section
      transition(name="slide-fade" mode="out-in")
        router-view.content.box
  router-view(name="store")
  router-view(name="print")
</template>

<script>
import shLoader from './components/layout/Loader'
import shMessage from './components/layout/Message'
import shMenu from './components/layout/Menu'

export default {
  name: 'App',

  components: { shLoader, shMessage, shMenu },

  computed: {
    menuPrincipalHidden () {
      return this.$store.state.interface.menuPrincipalHidden
    }
  },

  mounted () {
    this.$store.commit('connectSocket')
    this.$store.commit('login')
    this.$store.commit('getVariablesApp')
    this.$store.commit('initLanguage')
    this.$store.dispatch('initializeMenuListener')
  },
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'
@import '~@/stylus/reset.styl'
@import '~@/stylus/framework.styl'
@import '~@/stylus/icons.styl'
@import '~@/stylus/theme.styl'
@import '~@/stylus/animations.styl'
@import '~@/stylus/report.styl'

.app-layout
  display grid
  grid-template-columns auto 1fr
  width 100%
  height 100vh
  height 100dvh
  max-height 100dvh

.menu-section
  height 100%
  max-height 100dvh
  overflow hidden

.content-section
  height 100%
  overflow-y auto
  overflow-x hidden
  padding 1rem

@media print
  .menu-section
    display none
  .app-layout
    grid-template-columns 1fr

@media (max-width: 768px)
  .app-layout
    grid-template-columns 1fr
    grid-template-rows auto 1fr
    height 100dvh
    max-height 100dvh

  .menu-section
    height auto
    max-height none
    overflow visible

  .content-section
    min-height 0
    max-height 100dvh
</style>



// WEBPACK FOOTER //
// src/App.vue